/* eslint-disable react-hooks/rules-of-hooks */
import * as R from 'ramda'

const {
  ap,
  call,
  curry,
  identity,
  of,
  lensIndex,
  map,
  path,
  pipe,
  set,
  split,
  unapply,
  useWith
} = R
/**
 * Derivative function by property path in dot-notation for deep fields
 *
 * @func
 * @param {Array} list of property path(s) by dot-notation ('a.b.c') in string
 * @param {Object} object to be accessed
 * @example
 *      const obj = {
 *        a: { b: { c: 1 } },
 *        x: 2
 *      };
 *      propsDotPath(['a.b.c', 'x'], obj);
 *      // => [ 1, 2 ]
 * @reference https://github.com/ramda/ramda/wiki/Cookbook#derivative-of-rprops-for-deep-fields
 */
const dotPath = useWith(path, [split('.')])

export const propsDotPath = useWith(ap, [map(dotPath), of])
export const deepGet = useWith(path, [split('.'), identity])
export const callAll = (...funcs) => unapply(call(ap(funcs)))
export const renameProp = curry(
  (oldProp, newProp, { [oldProp]: oldValue, ...others }) => ({
    ...others,
    [newProp]: oldValue
  })
)
export const swap = (index1, index2, list) => {
  if (
    index1 < 0 ||
    index2 < 0 ||
    index1 > list.length - 1 ||
    index2 > list.length - 1
  ) {
    return list // index out of bound
  }

  return pipe(
    set(lensIndex(index1), list[index2]),
    set(lensIndex(index2), list[index1])
  )(list)
}
